import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Columns } from '../columns';
import { Section } from '../section';
import { SkeletonBlock, SkeletonStack } from '../skeleton';

export interface CatalogListLoaderProps {
    columns?: { xs: number; md: number; lg: number };
    itemsCount?: number;
}

const CatalogItemImageSkeleton = styled(SkeletonBlock)`
    width: 100%;
    height: auto;
    aspect-ratio: 1;
`;

export const CatalogListItemLoader: React.FC = () => (
    <SkeletonStack aria-hidden='true' $gap='10px'>
        <CatalogItemImageSkeleton $radius='0' />
        <SkeletonBlock $width='70%' $height='17px' $radius='3px' />
        <SkeletonBlock $width='40%' $height='17px' $radius='3px' />
    </SkeletonStack>
);

export const CatalogListLoaderContent: React.FC<CatalogListLoaderProps> = ({ columns, itemsCount = 10 }) => (
    <Columns $xs={columns?.xs ?? 2} $md={columns?.md ?? 5} $lg={columns?.lg ?? 5} $gap={30}>
        {new Array(itemsCount).fill(0).map((_, idx) => (
            <CatalogListItemLoader key={idx} />
        ))}
    </Columns>
);

export const CatalogListSkeleton: React.FC<PropsWithChildren<CatalogListLoaderProps>> = ({ children, columns, itemsCount }) => (
    <Section>
        {children}
        <CatalogListLoaderContent columns={columns} itemsCount={itemsCount} />
    </Section>
);

export const CatalogListLoader = <CatalogListLoaderContent />;
